
<template>
  <div class="salesVolume">
    <slot name="salesVolume"></slot>
  </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.salesVolume {
  background: #ffffff;
  color: #FF7C7C;
  border-top: 1px solid rgba(231,232,233,1);
}
.salesVolume a{
  color: #FF7C7C;
  display: block
}
</style>